// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3tGjK","header":"ClearentDisclaimer_header__2SZeQ","inner":"ClearentDisclaimer_inner__3Ogdi"};